import React from 'react';

interface AvatarProps {
  name?: string;
  fallback?: string;
  src?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
  className?: string;
}

export const Avatar: React.FC<AvatarProps> = ({ name, fallback, src, size = 'md', className = '' }) => {
  const sizeClasses = {
    xs: 'w-6 h-6 text-[10px]',
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base',
    xl: 'w-16 h-16 text-xl',
    '2xl': 'w-24 h-24 text-3xl',
    '3xl': 'w-[115px] h-[115px] text-4xl',
  };

  const initials = name
    ? name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .substring(0, 2)
      .toUpperCase()
    : fallback || '?';

  return (
    <div className={`relative inline-block ${className}`}>
      {src ? (
        <img
          src={src}
          alt={name || 'Avatar'}
          className={`${sizeClasses[size]} rounded-full object-cover border border-slate-200`}
        />
      ) : (
        <div
          className={`${sizeClasses[size]} rounded-full bg-os-primary/10 text-os-primary flex items-center justify-center font-medium border border-os-primary/20`}
        >
          {initials}
        </div>
      )}
    </div>
  );
};
